import { Edit, useTranslate, TextInput, SimpleForm, Toolbar, SaveButton } from 'react-admin';
import { Typography } from '@mui/material';
import { getLocalStorageId } from '../authProvider';
import useErrorHandler from '../common_modules/hooks/useErrorHandler';

const NoActions = () => null;
const CustomToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
);

export const ClientUrlEdit = () => {
  const translate = useTranslate();
  const recordId = getLocalStorageId();
  const handleError = useErrorHandler();
  console.log(recordId);
  if (!recordId) {
    return <div>ECサイトURLが取得できませんでした。</div>;
  }

  return (
    <Edit
      resource="client-url"
      id={recordId}
      mutationMode="pessimistic"
      mutationOptions={{ onError: handleError }}
      title={translate('resources.settings.fields.ecSiteUrl')}
      actions={<NoActions />}
      redirect={false}
      sx={{
        mt: '1rem'
      }}
    >
      <SimpleForm sx={{ mt: 1 }} spacing={2} toolbar={<CustomToolbar />}>
        <Typography
          sx={{
            fontSize: '14px'
          }}
        >
          以下にECサイトのURLを入力してください。
          <br />
          変更するとアフィリエイトURLにも反映されます。
        </Typography>
        <TextInput source="ecSiteUrl" fullWidth />
      </SimpleForm>
    </Edit>
  );
};
